

const BannerSection = () => {
  return (
    <section className="beauty-banner">

      <div className="banner-overlay"></div>

      <div className="banner-content">

        <span className="banner-tag">
          CELIORA SKINCARE
        </span>


        <h2>
          Reveal Your
          <br />
          Natural Glow
        </h2>


        <p>
          Korean inspired skincare crafted
          for Indian skin. Experience
          gentle formulas with powerful results.
        </p>


        <button>
          Explore Collection
        </button>

      </div>

    </section>
  );
};


export default BannerSection;